import config from 'config';
import { http_client } from './api';

const getList = async (query = null) => {
  return http_client.get(config.apiUrl + 'matchword', query).then((response) => {
    return response.data;
  });
};

const getListArchive = async (query = null) => {
  return http_client.get(config.apiUrl + 'matchword/archive', query).then((response) => {
    return response.data;
  });
};

const getAlHistory = async (query = null) => {
  return http_client.get(config.apiUrl + 'matchword/history', query).then((response) => {
    return response.data;
  });
};

const create = async (data) => {
  return http_client.post(config.apiUrl + 'matchword', data).then((response) => {
    return response.data;
  });
};

const read = async (id) => {
  return http_client.get(config.apiUrl + 'matchword/' + id).then((response) => {
    return response.data;
  });
};

const update = async (id, data) => {
  return http_client.post(config.apiUrl + 'matchword/' + id, data).then((response) => {
    return response.data;
  });
};

const del = async (id) => {
  return http_client.delete(config.apiUrl + 'matchword/' + id).then((response) => {
    return response.data;
  });
};

const changeStatus = async (id, data) => {
  return http_client.post(config.apiUrl + 'matchword/status/' + id, data).then((response) => {
    return response.data;
  });
};

const getHistory = async (id) => {
  return http_client.get(config.apiUrl + 'matchword/' + id + '/history').then((response) => {
    return response.data;
  });
};

const getSession = async (id, sessionID) => {
  return http_client.get(config.apiUrl + 'matchword/' + id + '/' + sessionID).then((response) => {
    return response.data;
  });
};

const getRatings = async (id, query) => {
  return http_client.get(config.apiUrl + 'matchword/' + id + '/ratings', query).then((response) => {
    return response.data;
  });
};

const copyMatchword = async (id, name, createdBy = null) => {
  return http_client.post(config.apiUrl + 'matchword/' + id + '/copy', { name, created_by: createdBy }).then((response) => {
    return response.data;
  });
};

const getShares = async (matchwordId) => {
  return http_client.get(config.apiUrl + 'matchword/' + matchwordId + '/shares').then((response) => {
    return response.data;
  });
};

const getEligibleTeachers = async (matchwordId) => {
  return http_client.get(config.apiUrl + 'matchword/' + matchwordId + '/shares/eligible').then((response) => {
    return response.data;
  });
};

const getEligibleForCopy = async (matchwordId) => {
  return http_client.get(config.apiUrl + 'matchword/' + matchwordId + '/shares/eligible', { params: { for_copy: true } }).then((response) => {
    return response.data;
  });
};

const addShares = async (matchwordId, teacherIds) => {
  return http_client.post(config.apiUrl + 'matchword/' + matchwordId + '/shares', { teacher_ids: teacherIds }).then((response) => {
    return response.data;
  });
};

const removeShare = async (matchwordId, teacherId) => {
  return http_client.delete(config.apiUrl + 'matchword/' + matchwordId + '/shares/' + teacherId).then((response) => {
    return response.data;
  });
};

const MatchWordService = {
  getList,
  getListArchive,
  getAlHistory,
  create,
  read,
  update,
  del,
  changeStatus,
  getHistory,
  getSession,
  getRatings,
  copyMatchword,
  getShares,
  getEligibleTeachers,
  getEligibleForCopy,
  addShares,
  removeShare
};

export default MatchWordService;
